import React from 'react';
import PropTypes from 'prop-types';

const SmallHeading = ({ name, tstyle='' }) => {
  return (
    <h1 className={`text-sm font-semibold text-emerald-600 uppercase ${tstyle}`}>
      {name}
    </h1>
  );
};

SmallHeading.propTypes = {
  name: PropTypes.string.isRequired,
  tstyle: PropTypes.string,
};

export default SmallHeading;
